module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancy":"0 вакансий | {n} вакансия | {n} вакансии | {n} вакансий","vacancies":"Вакансии","more":"Ещё","companyVacancies":"Вакансии компании","companyInfo":"Информация о компании"}}')
  delete Component.options._Ctor
}
